import Form from '@admin/components/form'
import PropTypes from 'prop-types'
import React from 'react'

class Strategy extends React.Component {

  static propTypes = {
    formdata: PropTypes.object,
    props: PropTypes.object,
    setup: PropTypes.object,
    onBack: PropTypes.func,
    onCancel: PropTypes.func,
    onChange: PropTypes.func,
    onNext: PropTypes.func,
    onSave: PropTypes.func
  }

  formRef = React.createRef()

  state = {
    config: {}
  }

  _handleBack = this._handleBack.bind(this)
  _handleChange = this._handleChange.bind(this)
  _handleSubmit = this._handleSubmit.bind(this)
  _handleSuccess = this._handleSuccess.bind(this)

  render() {
    return <Form { ...this._getForm() } />
  }

  _getForm() {
    const { advisor } = this.props.props
    const { config } = this.state
    return {
      ref: this.formRef,
      showHeader: false,
      buttons: [
        { label: 't(Previous)', color: 'blue', basic: true, handler: this._handleBack },
        { label: 't(Next)', color: 'blue', handler: this._handleSubmit }
      ],
      onChange: this._handleChange,
      onSuccess: this._handleSuccess,
      sections: [
        {
          fields: [
            { 
              label: 't(Entities)', 
              type: 'segment',
              fields: [
                { 
                  name: 'strategy', 
                  type: 'radiogroup',
                  options: [
                    { value: 'draft_version', text: 't(Overwrite existing entities and create new draft versions)' },
                    { value: 'create', text: 't(Create new entities)' }
                  ],
                  defaultValue: 'draft_version'
                },
                { 
                  label: 't(Theme)', 
                  name: 'theme_id', 
                  type: 'dropdown',
                  endpoint: `/api/admin/truevail/admin/advisors/${advisor.id}/themes`,
                  valueKey: 'id',
                  textKey: 'title',
                  selectFirst: true,
                  show: config.strategy !== 'create',
                  required: true
                },
                { 
                  label: 't(Email Template)', 
                  name: 'email_template_id', 
                  type: 'dropdown',
                  endpoint: `/api/admin/truevail/admin/advisors/${advisor.id}/templates`,
                  valueKey: 'id',
                  textKey: 'title',
                  selectFirst: true,
                  show: config.strategy !== 'create'
                },
                { 
                  label: 't(Forms)',
                  name: 'form_ids',
                  type: 'checkboxgroup',
                  endpoint: `/api/admin/truevail/admin/advisors/${advisor.id}/forms`,
                  valueKey: 'id',
                  textKey: 'title',
                  selectFirst: true,
                  show: config.strategy !== 'create'
                }
              ]
            }
          ]
        }
      ]
    }
  }

  _handleBack() {
    this.props.onBack()
  }

  _handleChange(config) {
    this.setState({ config })
  }

  _handleSubmit() {
    this.formRef.current.submit()
  }

  _handleSuccess(config) {
    this.props.onNext(config)
  }

}

export default Strategy